<div>
 
  <p class="page-title">Divisions</p>
  <div class="section-wrapper tabletab">
    <np-tabbed>
      <ul class="tabs">
        <li role="tab" (click)="changeNav()" aria-selected="true">Manage Divisions</li>
        <li role="tab" aria-selected="false">Add New Division</li>
      </ul>

      <div class="tab-content" role="tabpanel" aria-hidden="false">
        <div class="mt-10 mb-10">
          <div class="exportBtnContainer">
            <button (click)="exportToExcel()" class="primary-btn">Export To Excel</button>
          </div>
          <div >
          <p-table
            [value]="divisionData"
            [scrollable]="true"
            scrollHeight="400px"
            [virtualRowHeight]="20"
            styleClass="division-table p-datatable-gridlines"
            id="StyleTable"
          >
            <ng-template pTemplate="header">
              <tr>
                <th >Division</th>
                <th >Maximo Code</th>
                <th >Status</th>
                <th >Action To Take</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td>{{ row.DivisionName }}</td>
                <td>{{ row.DivisionMaximo  }}</td>
                <td [ngClass]="row.cssClass">{{ row.status }}</td>
                <td [ngClass]="row.cssClass" class='text-center'>
                  <!-- <p-button>{{ row.DivisionRetired }}</p-button> -->
                  <button (click)="retire(row)" [ngClass]="row.buttonName =='Retire'?'btn-success': 'btn-warning'">{{ row.buttonName }}</button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        </div>
      </div>

      <div class="tab-content" #manageGrid role="tabpanel" aria-hidden="true">
        <p class="boldOne">
          Prior to adding a new division, make sure that the external
          maintenance application is configured to relate to the new division.
        </p>
        <p class="errorText" *ngIf="errorData">Please enter required field.</p>
        <p class="errorText" *ngIf="SaveSuccess">The item has been successfully added.</p>
        <div class="manage-details-container">
          <div class="section-title boldOne">Enter Division Data</div>
          <div class="partioned-table">
            <div class="row">
              <div class="cell label">Division</div>
              <div class="cell value d-flex">
                <input [(ngModel)]="newDivisionName" maxlength="20" />
                <p class="errorText">  * Required Field</p>

              </div>
            </div>
            <div class="row">
                <div class="cell label">Maximo</div>
                <div class="cell value d-flex">
                  <input [(ngModel)]="newMaximoCode" maxlength="6" />
                  <p class="errorText">  * Required Field</p>
                </div>
              </div>
            <div class="row">
                <div class="cell label"></div>
                <div class="cell value">
                  <p-button label="Add New Division" styleClass="primary-btn"  (click)="addDivision()"></p-button>
                </div>
              </div>
          </div>
        </div>
      </div>
    </np-tabbed>
  </div>
</div>
